import { useEffect, useState, useRef } from "react";
import { Badge, Drawer, List, Typography } from "antd";
import { BellOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import axios from "axios";

const NotificationBar = ({ backUrl, authData }) => {
  const [notifications, setNotifications] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const intervalRef = useRef(null);
  const navigate = useNavigate();

  /* ------------------ Fetch Notifications ------------------ */
  const fetchNotifications = async () => {
    try {
      const res = await axios.get(
        `${backUrl}/api/probation/notifications/`,
        {
          headers: { Authorization: `Bearer ${authData?.access}` },
        }
      );

      const sorted = [...res.data.results].sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );

      setNotifications(sorted);
    } catch (err) {
      console.error("Error loading notifications", err);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  /* ------------------ Auto Rotate Every 10s ------------------ */
  useEffect(() => {
    if (notifications.length === 0 || drawerVisible) return;

    intervalRef.current = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % notifications.length);
    }, 10000);

    return () => clearInterval(intervalRef.current);
  }, [notifications, drawerVisible]);

  /* ------------------ Mark as Read ------------------ */
  const markasread = async (id) => {
    try {
      await axios.post(
        `${backUrl}/api/probation/notifications/${id}/mark-as-read/`,
        {},
        {
          headers: {
            Authorization: `Bearer ${authData?.access}`,
          },
        }
      );

      // ✅ Update UI immediately
      setNotifications((prev) =>
        prev.map((n) =>
          n.id === id ? { ...n, is_read: true } : n
        )
      );
    } catch (err) {
      console.error("Mark as read failed", err);
    }
  };

  /* ------------------ Click Notification ------------------ */
  const handleNotificationClick = (item) => {
    // setDrawerVisible(false);
    // navigate(item.link);
  };

  return (
    <>
      {/* Floating Bell */}
      <div
        style={{
          position: "fixed",
          bottom: 60,
          right: 60,
          zIndex: 2000,
          background: "#0e497b",
          color: "white",
          padding: "15px",
          borderRadius: "50%",
          boxShadow:
            "0 10px 20px rgba(0, 0, 0, 0.35), 0 6px 6px rgba(0, 0, 0, 0.22)",
        }}
      >
        <Badge
          count={notifications.filter((n) => !n.is_read).length}
          size="small"
        >
          <BellOutlined
            style={{ fontSize: 28, color: "white", cursor: "pointer" }}
            onClick={() => setDrawerVisible(true)}
          />
        </Badge>
      </div>

      {/* Drawer */}
      <Drawer
        title="Notifications"
        placement="right"
        width={480}
        onClose={() => setDrawerVisible(false)}
        open={drawerVisible}
      >
        <List
          itemLayout="vertical"
          dataSource={notifications}
          renderItem={(item) => (
            <List.Item
              style={{
                cursor: "pointer",
                fontWeight: item.is_read ? "normal" : "bold",
                opacity: item.is_read ? 0.7 : 1,
                backgroundColor: item.is_read ? "transparent" : "#f6f9ff",
                borderRadius: 6,
                padding: "12px",
              }}
              onClick={() => {
                markasread(item.id);
                handleNotificationClick(item);
              }}
            >
              <Typography.Text
                style={{
                  fontWeight: item.is_read ? "normal" : "bold",
                }}
              >
                {item.message}
              </Typography.Text>

              <br />

              <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                {dayjs(item.created_at).format("DD MMM YYYY, hh:mm A")}
              </Typography.Text>
            </List.Item>
          )}
        />
      </Drawer>
    </>
  );
};

export default NotificationBar;
